"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var consoleLogger_1 = require("./logger/consoleLogger");
var PlanConfiguration = (function () {
    function PlanConfiguration() {
    }
    PlanConfiguration.targetingTreeKey = "AGOF_TT";
    PlanConfiguration.tableHeadColor = "Black";
    PlanConfiguration.tableColor = "Black";
    PlanConfiguration.selectedRow = "#6BC0FF";
    PlanConfiguration.selectedRowInactive = "#ADC1D6";
    PlanConfiguration.currentSelectedRow = "#6BC0FF";
    PlanConfiguration.selectedWarnRow = "#CBC0AC";
    PlanConfiguration.selectedErrorRow = "#C0B1C8";
    PlanConfiguration.corruptedRow = "#EDA9AA";
    PlanConfiguration.warningRow = "#FFC080";
    PlanConfiguration.groupRow = "#DEEAF6";
    PlanConfiguration.greyButtonBackground = "#F7F7F7";
    PlanConfiguration.disabledButtonBackground = "#D7D7D7";
    PlanConfiguration.gridBorderColor = "#CECECE";
    PlanConfiguration.textFieldBackground = "#FFF";
    PlanConfiguration.standardTableBackground = "#ECF7FF";
    PlanConfiguration.gridHeaderBackground = "#ECECEC";
    PlanConfiguration.buttonBackground = "#3291D6";
    PlanConfiguration.buttonText = "#CFE5F5";
    PlanConfiguration.buttonPadding = 5;
    PlanConfiguration.borderWidth = 3;
    PlanConfiguration.comboBackground = "#FFF";
    PlanConfiguration.textColor = "#000";
    PlanConfiguration.borderColor = "#CECECE";
    PlanConfiguration.textFieldSelectionColor = "#D0EAFF";
    PlanConfiguration.errorFontColor = "#C00000";
    PlanConfiguration.warningFontColor = "#FF0000";
    PlanConfiguration.linkFontColor = "#3A93D3";
    PlanConfiguration.tableHeadHeight = 50;
    PlanConfiguration.tableDefaultWidth = 75;
    PlanConfiguration.fontSize = 11;
    PlanConfiguration.fontType = "helvetica";
    PlanConfiguration.rowHeight = 20;
    PlanConfiguration.planDetailsToCache = 50;
    PlanConfiguration.cellXPadding = 5;
    PlanConfiguration.cellYPadding = 0;
    PlanConfiguration.hoverPopupFontColor = "#202020";
    PlanConfiguration.hoverPopupBackgroundColor = "FFF";
    PlanConfiguration.hoverPopupBorderColor = "#CECECE";
    PlanConfiguration.hoverPopupWidth = 200;
    PlanConfiguration.hoverPopupPadding = 3;
    PlanConfiguration.hoverPopupBorderRadius = 0;
    PlanConfiguration.maxEditableRowsViaPreset = -1;
    PlanConfiguration.iconSize = 12;
    PlanConfiguration.flowLayoutGap = 10;
    PlanConfiguration.NUMBER_FORMAT_PERCENT = "0.0";
    PlanConfiguration.NUMBER_FORMAT_CURRENCY = "0,000.00";
    PlanConfiguration.NUMBER_FORMAT_INTEGER = "0,000";
    PlanConfiguration.NUMBER_FORMAT_NODIGITS = "0";
    PlanConfiguration.NUMBER_FORMAT_2DIGITS = "0.00";
    PlanConfiguration.INPUT_BACKGROUND_COLOR = "#FFF";
    PlanConfiguration.ERROR_STRING = "-";
    PlanConfiguration.apiLanguage = "de";
    PlanConfiguration.dataMultiplierFields = ["{$CTS:UNDER_10}", "{$CTS:UNDER_30}", "{$CTS:UNDER_60}", "{$CTS:UNDER_300}", "{$CTS:OVER_300}"];
    PlanConfiguration.smallFontOffset = -0.5;
    PlanConfiguration.bigFontOffset = 1;
    PlanConfiguration.totalGridScrollHeight = 40;
    PlanConfiguration.comboButtonSize = 10;
    PlanConfiguration.comboWidth = 1000;
    PlanConfiguration.rawSampleTotalThreshold = 351;
    PlanConfiguration.rawSampleMediumThreshold = 80;
    PlanConfiguration.limitationText = "**";
    PlanConfiguration.defaultTimeOut = 10000;
    PlanConfiguration.missed67shortMessage = "n.i.Ztr.";
    PlanConfiguration.missed67longMessage = "nicht im Zeitraum - Das Medium wird im gewählten Zeitraum nicht ausgewiesen. Berechnung der Belegung erfolgt nur bei Wahl eines Zeitraums mit Ausweis.";
    PlanConfiguration.logger = new consoleLogger_1.ConsoleLogger(consoleLogger_1.LogLevel.off);
    return PlanConfiguration;
}());
exports.PlanConfiguration = PlanConfiguration;
//# sourceMappingURL=configuration.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/configuration.js
// module id = 5
// module chunks = 0